export default function buildFormData(data, parentKey = null, formData = new FormData()) {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      if (Array.isArray(data[key]) && data[key].length === 0) {
        formData.append(`${key}[0]`, null);
      }

      buildFormData(data[key], parentKey ? `${parentKey}[${key}]` : key, formData);
    });
  } else {
    const value = data == null ? '' : data;

    formData.append(parentKey, value);
  }

  return formData;
}
